// extracted by css-extract-rspack-plugin
module.exports =  {"copyJobErrorJobId":"BulkActionJobErrorDialog__copyJobErrorJobId___eYFnt","copyJobErrorMessage":"BulkActionJobErrorDialog__copyJobErrorMessage___k7NGs"};